/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { getConstants } from '../actions/actionType';

export function DistributorList(state = {}, action) {
    switch (action.type) {
    case getConstants.GET_DISTRIBUTORS_LIST_SUCCESS:
        return {
            type: getConstants.GET_DISTRIBUTORS_LIST_SUCCESS,
            distributors: action.user.data.data,
            pagination: action.user.data.number_of_pages,
        };
    case getConstants.GET_DISTRIBUTORS_LIST_FAILURE:
        return {
            type: getConstants.GET_DISTRIBUTORS_SUCCESS,
            message: action.message,
        };
    default:
        return state;
    }
}
